import * as React from "react";
import { Fragment } from "react";

const TopLabelFieldTemplate = (props: any) => {
  const {
    classNames,
    label,
    help,
    required,
    description,
    errors,
    children
  } = props;

  return (
    <div className={`p-field ${classNames}`}>
      <div className="text-xs font-medium pb-0.5">
      {label}
        {required ? "*" : null}
      </div>
      {description}
      {children}
      <>
        {errors.props.errors &&
          errors.props.errors.map((error: any, index: number) => (
            <Fragment key={index}>
              <small className="p-d-block p-error">{error}</small>
            </Fragment>
          ))}
      </>
      {help}
    </div>
  );
};

export default TopLabelFieldTemplate;
